<div class="main">
    <app-header-section></app-header-section>
    <app-breadcrumb-explore-two></app-breadcrumb-explore-two>
    <app-explore-three-section></app-explore-three-section>
    <app-footer-section></app-footer-section>
    <app-modal-search></app-modal-search>
    <app-modal-menu></app-modal-menu>
    <app-scrollup></app-scrollup>
</div>
